/* ==========================================================================
   Meridian - "Built to stack" configurator
   Click-to-toggle product rows, live subtotal/discount-tier/total preview,
   pot tray visualisation, "Add stack" adds every selected product as its
   own cart line via the shared meridian:add-to-cart event.
   ========================================================================== */
(function () {
  'use strict';

  document.querySelectorAll('[data-stack-configurator]').forEach(initStack);

  function moneyFormat(cents) {
    var format = (window.Shopify && window.Shopify.money_format) || '£{{amount}}';
    return format.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
  }

  function initStack(root) {
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-stack-row]'));
    var tray = root.querySelector('[data-stack-tray]');
    var emptyLabel = root.querySelector('[data-stack-empty-label]');
    var selectedCountEl = root.querySelector('[data-stack-selected-count]');
    var subtotalEl = root.querySelector('[data-stack-subtotal]');
    var tierLabelEl = root.querySelector('[data-stack-tier-label]');
    var tierValueEl = root.querySelector('[data-stack-tier-value]');
    var totalEl = root.querySelector('[data-stack-total]');
    var addBtn = root.querySelector('[data-stack-add]');

    var tier1Qty = parseInt(root.getAttribute('data-tier1-qty'), 10) || 3;
    var tier1Pct = parseInt(root.getAttribute('data-tier1-pct'), 10) || 10;
    var tier2Qty = parseInt(root.getAttribute('data-tier2-qty'), 10) || 5;
    var tier2Pct = parseInt(root.getAttribute('data-tier2-pct'), 10) || 15;

    var totalAvailable = rows.length;
    var selected = [];

    function rateFor(count) {
      if (count >= tier2Qty) return tier2Pct / 100;
      if (count >= tier1Qty) return tier1Pct / 100;
      return 0;
    }

    function render() {
      rows.forEach(function (row) {
        var mark = row.querySelector('[data-stack-mark]');
        var isSel = selected.indexOf(row) > -1;
        row.classList.toggle('is-selected', isSel);
        if (mark) mark.textContent = isSel ? '[×]' : '[ ]';
      });

      tray.querySelectorAll('[data-stack-pot]').forEach(function (el) { el.remove(); });
      if (emptyLabel) emptyLabel.style.display = selected.length ? 'none' : '';
      selected.forEach(function (row) {
        var pot = document.createElement('div');
        pot.className = 'm-stack__pot';
        pot.setAttribute('data-stack-pot', '');
        pot.innerHTML =
          '<div class="m-stack__pot-cap" style="background-color:' + row.getAttribute('data-accent-cap') + ';"></div>' +
          '<div class="m-stack__pot-body" style="background-color:' + row.getAttribute('data-accent-colour') + ';color:' + (row.getAttribute('data-accent-on') === 'ink' ? 'var(--ink)' : 'var(--paper)') + ';">' +
            '<span class="m-stack__pot-name">' + row.getAttribute('data-plain-name') + '</span>' +
          '</div>';
        tray.appendChild(pot);
      });

      var gross = selected.reduce(function (sum, row) { return sum + parseInt(row.getAttribute('data-price'), 10); }, 0);
      var eligible = selected.filter(function (r) { return r.getAttribute('data-multibuy') !== 'false'; });
      var eligGross = eligible.reduce(function (sum, row) { return sum + parseInt(row.getAttribute('data-price'), 10); }, 0);
      var rate = rateFor(eligible.length);
      var net = gross - Math.round(eligGross * rate);

      if (selectedCountEl) selectedCountEl.textContent = selected.length + ' / ' + totalAvailable;
      if (subtotalEl) subtotalEl.textContent = selected.length ? moneyFormat(gross) : '-';

      if (rate > 0) {
        if (tierLabelEl) tierLabelEl.textContent = 'Saving ' + (rate * 100) + '%';
        if (tierValueEl) { tierValueEl.textContent = '−' + moneyFormat(gross - net); tierValueEl.style.color = 'var(--blue)'; }
      } else {
        var remaining = eligible.length < tier1Qty ? (tier1Qty - eligible.length) : (tier2Qty - eligible.length);
        var nextPct = eligible.length < tier1Qty ? tier1Pct : tier2Pct;
        var nextLabel = eligible.length >= tier2Qty ? 'Maximum saving reached' : (remaining + ' more for ' + nextPct + '% off');
        if (tierLabelEl) tierLabelEl.textContent = 'Next tier';
        if (tierValueEl) { tierValueEl.textContent = nextLabel; tierValueEl.style.color = ''; }
      }

      if (totalEl) totalEl.textContent = selected.length ? moneyFormat(net) : '-';

      if (addBtn) {
        addBtn.disabled = selected.length === 0;
        addBtn.classList.toggle('is-active', selected.length > 0);
        addBtn.textContent = selected.length ? ('Add stack - ' + moneyFormat(net)) : 'Select at least one formula';
      }
    }

    rows.forEach(function (row) {
      row.addEventListener('click', function () {
        var idx = selected.indexOf(row);
        if (idx > -1) selected.splice(idx, 1);
        else selected.push(row);
        render();
      });
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (!selected.length) return;
        var items = selected.map(function (row) {
          return {
            id: parseInt(row.getAttribute('data-variant-id'), 10),
            quantity: 1,
            properties: { _accent_colour: row.getAttribute('data-accent-colour') }
          };
        });
        document.dispatchEvent(new CustomEvent('meridian:add-to-cart', {
          detail: { items: items, flashText: 'Added - stack of ' + items.length }
        }));
      });
    }

    render();
  }
})();
